import { useGlobalState } from '../../../../state/v2/store';
import { useInsightsFilterMenuParams } from '../FilterMenu/useFilterMenuParams';
import { useEffect, useMemo } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { Insight } from '../InsightsTable/InsightsTable';
import { useSafeLabelLiftQueryQuery } from './__generated__/useSafeLabelLiftQueryQuery.graphql';
import { labelTypeToGraphqlEnum } from '../../../../common';

export interface LabelLiftData {
  period: string;
  lift: number;
  adsCount: number;
  spendPresent: number;
  kpiPresent: number;
}

export const useSafeLabelLiftQuery = ({
  insight,
  kpi,
  insightsGraphEnabled,
  labelLiftCache,
  setLabelLiftCache,
}: {
  insight: Insight;
  kpi: any;
  insightsGraphEnabled: boolean;
  labelLiftCache: Record<string, LabelLiftData[]>;
  setLabelLiftCache: (cache: Record<string, LabelLiftData[]>) => void;
}) => {
  const [{ performanceDateGte, performanceDateLte }] = useInsightsFilterMenuParams();
  const brandId = useGlobalState((b) => b.brand?.map((brand) => brand.id).join(','));
  
  const getCleanLabelType = () => {
    const token = labelTypeToGraphqlEnum(insight.labelType)
    return token || undefined
  }

  const variables = useMemo(
    () =>
      ({
        skip: !insightsGraphEnabled || !brandId,
        input: {
          labelName: insight.labelName,
          labelType: getCleanLabelType(),
          brandId: brandId!,
          kpi,
          performanceDateRange:
            performanceDateGte && performanceDateLte
              ? {
                  start: performanceDateGte,
                  end: performanceDateLte,
                }
              : undefined,
        },
      } as useSafeLabelLiftQueryQuery['variables']),
    [insight.labelName, insight.labelType, brandId, kpi, performanceDateGte, performanceDateLte, insightsGraphEnabled]
  );

  const result = useLazyLoadQuery<useSafeLabelLiftQueryQuery>(
      graphql`
        query useSafeLabelLiftQueryQuery($input: LabelLiftRequest!, $skip: Boolean!) {
          labelLiftData(input: $input) @skip(if: $skip) {
            period
            lift
            adsCount
            spendPresent
            kpiPresent
          }
        }
      `,
      variables,
      { fetchPolicy: 'network-only' }
    );

  useEffect(() => {
    const skip = !insightsGraphEnabled || !brandId
    console.log('[useSafeLabelLiftQuery]', {
      skip,
      skipBecause: skip
        ? !insightsGraphEnabled
          ? 'insightsGraphEnabled=false'
          : 'missing brandId'
        : null,
      insightId: insight.id,
      labelName: insight.labelName,
      seriesLength: result.labelLiftData?.length ?? 0,
    })
  }, [insightsGraphEnabled, brandId, insight.id, insight.labelName, result.labelLiftData])

  if (result?.labelLiftData && !labelLiftCache[insight.id]) {
    setLabelLiftCache({
      ...labelLiftCache,
      [insight.id]: [...result.labelLiftData],
    });
    
  }
  return result;
};
